enum Reducers {
  UI = 'ui',
  Auth = 'auth',
  Quiz = 'quiz',
  Question = 'question',
  Player = 'player',
  Rokt = 'rokt',
  Consent = 'consent',
  Pages = 'pages',
  QuizEvents = 'quizEvents',
  QuizGroup = 'quizGroup'
};

export default Reducers;
